import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]

import { inject, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tab',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;

const selectedTitle = inject('SelectedTitle');

const tabId = computed(() => `tab-${props.title}`);
const panelId = computed(() => `panel-${props.title}`);

return (_ctx: any,_cache: any) => {
  return (_unref(selectedTitle) === _ctx.title)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tab",
        role: "tabpanel",
        id: panelId.value,
        "aria-labelledby": tabId.value
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})